import { h } from 'preact';

const ControlWrapper = ({
  shouldShow,
  children
}: {
  shouldShow: boolean
  children: any
}) => {
  if (!shouldShow) {
    return null;
  }
  return <>{children}</>;
};

export default ControlWrapper;
